import React from "react";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import DepartmentForm from "../Department/DepartmentForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Department" : "Create Department";
};

const DepartmentPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  return (
    <RightSideModel
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      title={titlePopup(Boolean(recordForEdit))}
    >
      <DepartmentForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />
    </RightSideModel>
  );
};

export default DepartmentPopup;
